import axios from '@/utils/axios'
import i18n from '@/i18n/i18n'
import { NormalizedError } from '@/utils/normalize-error.js'

/** @typedef {import('@/types/models').Currency} Currency */

export default {
  /**
   * @returns {Promise<Currency[]>}
   */
  async fetchCurrencies() {
    try {
      const response = await axios.get('/xhr/currencies')
      return response.data
    } catch {
      const message = i18n.t('Could not load currencies.')
      throw new NormalizedError(message, 'api.currencies.failed_to_load_currencies')
    }
  },
}
